import React from "react";

/* --------------------------------
   Signature (Inline SVG)
--------------------------------- */
function Signature() {
  return (
<svg
  viewBox="0 0 1613.92 593.87"
  role="img"
  aria-label="Renée Gebhardt Signatur"
  className="w-[90%] md:w-[50%] max-w-5xl mx-auto -translate-x-8 md:-translate-x-9 rotate-[1.5deg]"
    >
      <defs>
        <style>{`
          .signature-path {
            fill: none;
            stroke: #d4d4d8;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 3px;
          }
          @media (max-width: 768px) {
            .signature-path {
              stroke-width: 4px;
            }
          }
        `}</style>
      </defs>

      <path className="signature-path" d="M360.27,373.34s-48.87,63.09-68.05,95.08c-19.18,31.99-34.29,55.61-37.13,53.15-2.84-2.46-5.85-8.01,39.79-63.9,45.63-55.89,127.61-144.09,171.26-133.57,8.76,2.11,11.79,7.7,12.13,13.96.55,10.15-7.56,24.41-22.5,38.87-17.91,17.35-45.21,35.02-73.28,46.59-20.84,8.59-39.66,15.55-51.52,21.74-8.22,4.3-13.12,8.75-12.92,10.99.98,10.61,14.2,18.88,66.58,30.8,47.83,10.89,47.81-5.4,47.81-5.4,0,0-3.76.38-4.81,3.55s-4.83,4.3-4.83,4.3" />

      <path className="signature-path" d="M629.54,463.5c-7.03,2.86-26.8,16.15-29.87,2.53s8.06-41.18,15.74-44.74c7.59-3.52,5.88,12.82,0,19.14-11.22,12.06-31.68,26.66-43.33,32.15-12.51,5.9-14.06,3.73-8.35-12.3s22.41-33.83,16.48-33.83-21.21,13.28-40.43,29.66c-23.29,19.86-25.61,21.23-24.72,12.08.68-7,11.64-41.74,8.57-42.62s-14.54,14.89-25.27,23.95c-23.29,19.66-37.35,22.63-46.36,25.49-9.01,2.86-29.53,1.33-9.01-32.52,20.53-33.85,36.25-37.13,39.77-34.05s-5.05,18.02-28.78,33.61-30.32,7.91-30.32,7.91c0,0,.18-.74.88.15" />

      <path className="signature-path" d="M697.3,474.96s-6.15,2.66-11.46,5.63c-20.84,11.64-44.6,7.03-39.77-20.21s25.49-47.02,39.55-49.97c9.18-1.93,15.5,3.73,1,15.38s-41.86,16.14-41.86,16.14c0,0,7.45-4.17,16.24-3.95" />

      <path className="signature-path" d="M683.64,352.3s-10.55,4.3-28.01,14.18-33.61,22.56-35.43,23.22-7.09-.99-7.09-.99c0,0,2.73-1.15,4.87-.33" />

      <path className="signature-path" d="M937.26,467.17c-13.62,6.15-37.35,18.62-42.62,13.41-5.27-5.22-3-19.75,23.36-47,26.36-27.24,49.02-34.39,53.41-27.36s-24.8,29.21-63.08,38.86c-45.48,11.46-59.24,10.08-97.47,30.29-38.23,20.21-79.83,61.91-88.84,97.06-5.97,23.3,3.08,31.75,34.71-9.67,32.08-41.99,32.08-82.17,94.91-172.25,62.84-90.08,92.28-99.75,102.38-94.91,10.11,4.83,1.76,25.49-10.11,41.74-11.86,16.26-24.61,17.14-24.61,17.14,0,0-.12-2.61,3.83-2.83,0,0,3.13,1.32,10.16-3.52" />

      <path className="signature-path" d="M1069.96,325s-60.86,81.73-76.68,119.08-15.82,45.7-8.79,45.7,38.23-32.96,43.58-55.47c5.01-21.07-.52-37.27-23.93-26.73" />

      <path className="signature-path" d="M1126.83,368.65s18.89-20.88,13.18-27.58c-5.71-6.7-36.36,18.24-66.24,64.82-29.88,46.58-28.14,64.25-26.36,69.87,3.08,9.72,13.15-9.19,36.68-32.53,28.79-28.55,50.32-40.78,60.86-34.85,9.15,5.15-11.86,42.33-18.46,55.07-6.59,12.74-8.35,24.61,0,21.53,8.35-3.08,48.33-25.64,63.71-53.25,15.38-27.6,14.06-39.03,3.52-43.86s-12.74,1.32-12.74,1.32c0,0,1.32,3.08,7.03.88" />

      <path className="signature-path" d="M1192.32,427.87s5.36-13.18-7.38-13.18-37.79,22.41-30.32,36.91c7.47,14.5,14.65,6.59,47.09,8.35,32.44,1.76,60.57,5.71,67.16,9.67s-5,5.78-17.77-1-31.78-34.24-30.12-48.21c1.54-12.96,5.49-9.01,17.14-16.7,0,0,2.42-1.43.11-1.87" />

      <path className="signature-path" d="M1611.92,419.39s-37.24-5.05-94.91-3.95c-76.29,1.45-124.88,20.13-125.54,15.18-.33-2.48,17.79-22.42,33.34-43.64,15.42-21.04,28.27-43.38,29.91-43.38,3.3,0-30.65,66.24-52.07,87.33-21.42,21.09-47.46,46.47-50.06,46.47s-5.31,6.59,12.16-41.52c17.47-48.12,64.26-139.4,70.2-139.4s-22.72,63.88-42.16,88.92-49.33,49.4-72.07,63.57c-22.74,14.17-42.38,28.16-39.88,5.27,2.64-24.06,27.75-48.77,38.3-50.42s24.72.94,30.65,18.41c5.93,17.47-7.63,33.58-9.6,31.93s-6.9-1-6.9-1c0,0,8.74.67,12.49-4.19" />
    </svg>
  );
}

/* --------------------------------
   Footer
--------------------------------- */
export default function Footer() {
  return (
    <footer className="pt-0 px-12 pb-16 border-t border-zinc-800 bg-black">
      <div className="container-max">
        <div className="mb-6 text-center text-zinc-200">
          <Signature />
        </div>

        <div className="text-zinc-500 flex gap-4 md:gap-8 flex-wrap justify-center mb-10">
          <a
            href="https://linkedin.com/in/renegebhardt"
            target="_blank"
            rel="noopener noreferrer"
            className="no-underline transition-colors whitespace-nowrap font-medium hover:text-white"
            style={{ fontSize: "clamp(17px, 2vw, 14px)" }}
          >
            LinkedIn
          </a>
          <a
            href="/imprint"
            className="no-underline transition-colors whitespace-nowrap font-medium hover:text-white"
            style={{ fontSize: "clamp(17px, 2vw, 14px)" }}
          >
            Imprint
          </a>
          <a
            href="/privacy"
            className="no-underline transition-colors whitespace-nowrap font-medium hover:text-white"
            style={{ fontSize: "clamp(17px, 2vw, 14px)" }}
          >
            Privacy
          </a>
        </div>

        <div className="text-center text-zinc-700 leading-relaxed">
          <p className="m-0" style={{ fontSize: "clamp(17px, 2vw, 12px)" }}>© 2006–{new Date().getFullYear()}</p>
          <p className="mt-0.5 italic" style={{ fontSize: "clamp(17px, 2vw, 12px)" }}>Still making things that scare me</p>
        </div>
      </div>
    </footer>
  );
}